import React, {Component} from 'react';
import * as settings from '../settings';

export default class GoogleMapsLink extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <a target="_blank"
               className="map-component__link"
               href={settings.googleMapsWebUrl
               + this.props.lat
               + ","
               + this.props.lng}>
                Show in Google Maps
            </a>
        )
    }
}